// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "c8135c7d36ec2970","396": "5249bd0109c21ea8","460": "eb06d88dc6bde293","498": "77f083abb919f510","917": "c586c09874fb848e","985": "4a9bbf5f621e175b",}[chunkId] + ".chunk.js"
}